/**
 * Created by Ning Jiang on 11/17/2016.
 */

import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}

import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require ("pixi-spine");

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {Deadwood} from "./game/Deadwood";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {DeadwoodIntroConfig} from "./game/intro/DeadwoodIntroConfig";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {DeadwoodPromoPanelConfig} from "./game/server/DeadwoodPromoPanelConfig";

declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new Deadwood(),
    new SlotKeypad(),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new DeadwoodPromoPanelConfig()),
    new NolimitGameIntroPlugin(new DeadwoodIntroConfig())
]);
